module.exports = __webpack_public_path__ + "static/media/paperclip.65b3f8c9.svg";